import { render, staticRenderFns } from "./LeaveReasonModal.vue?vue&type=template&id=e6b260d4&"
import script from "./LeaveReasonModal.vue?vue&type=script&lang=js&"
export * from "./LeaveReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports